import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateUserNotificationCount } from "store/actions/Profile/profile";
import {
  getCustomerNotifications,
  updateNotificationsStatus,
} from "store/services/Notifications";

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const { selectedStore } = useSelector((store) => store.selectedStore);
  const { user } = useSelector((store) => store.userReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchUserNotifications = async () => {
      try {
        if (user && selectedStore) {
          const userNotifications = await getCustomerNotifications(
            user.accessToken,
            user.data.id,
            selectedStore.id
          );
          if (userNotifications.success) {
            const latestNotificationFirst =
              userNotifications.data.notifications.sort(
                (a, b) => b.notification_time - a.notification_time
              );
            setNotifications(latestNotificationFirst);
            const updateStatus = await updateNotificationsStatus(
              user.accessToken,
              user.data.id
            );
            if (updateStatus.success) {
              dispatch(updateUserNotificationCount(0));
            }
          }
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchUserNotifications();
  }, [user, selectedStore, dispatch]);
  return (
    <div className="p-3 overflow-auto text-black lg:w-80 w-72 md:w-80 h-96">
      <div className="font-bold text-gray-700 border-b-2 ">Notifications</div>
      {notifications && notifications.length === 0 ? (
        <div className="flex items-center justify-center h-full text-sm text-gray-600">
          No new notifications
        </div>
      ) : (
        notifications.map((notification) => (
          <div
            key={notification.id}
            className="p-2 my-2 text-xs bg-gray-100 border rounded-md"
          >
            <div className="flex items-center gap-1 px-1 font-bold justify-evenly">
              <div className="w-3/4">{notification.notification_title}</div>
              <div className="w-1/4">
                <img
                  className="w-32 h-auto"
                  src={notification.notification_image}
                  alt="logo"
                />
              </div>
            </div>
            <div className="flex items-center justify-between gap-1 px-1">
              <div>By: {notification.notification_body}</div>
              <div>{notification.createdAt}</div>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default Notifications;
